import { atom } from "@byko/lib-recoil";

import type { Checkout } from "@byko/lib-api-rest";

export const checkoutDataState = atom<Checkout | null>({
  key: "checkout-data",
  default: null,
});
